import { useState, useEffect } from 'react';
import { companyInfo } from '@/mocks/home';
import { getGenericWhatsAppUrl } from '@/utils/whatsapp';

export default function FloatingButtons() {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-50 flex flex-col gap-3 pb-safe">
      {showBackToTop && (
        <button
          onClick={scrollToTop}
          className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-white border border-background-200/70 text-foreground-700 hover:text-primary-500 hover:border-primary-300 flex items-center justify-center transition-all duration-300 cursor-pointer animate-fade-in"
          aria-label="Back to top"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-up-line text-lg" />
          </div>
        </button>
      )}

      <a
        href={`tel:${companyInfo.phone1.replace(/\s/g, '')}`}
        className="w-11 h-11 md:w-12 md:h-12 rounded-full bg-primary-500 text-white hover:bg-primary-600 flex items-center justify-center transition-all duration-300 hover:scale-105 cursor-pointer"
        aria-label="Call now"
      >
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-phone-line text-lg" />
        </div>
      </a>

      <a
        href={getGenericWhatsAppUrl()}
        target="_blank"
        rel="noopener noreferrer"
        className="relative w-11 h-11 md:w-12 md:h-12 rounded-full bg-secondary-500 text-white hover:bg-secondary-600 flex items-center justify-center transition-all duration-300 hover:scale-105 group cursor-pointer"
        aria-label="WhatsApp"
      >
        <div className="relative w-5 h-5 flex items-center justify-center">
          <i className="ri-whatsapp-line text-lg" />
        </div>
      </a>
    </div>
  );
}